import { render } from "./ProductHunt.vue?vue&type=template&id=bbdbced0&scoped=true"
import script from "./ProductHunt.vue?vue&type=script&lang=js"
export * from "./ProductHunt.vue?vue&type=script&lang=js"

import "./ProductHunt.vue?vue&type=style&index=0&id=bbdbced0&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbdbced0"]])

export default __exports__